import React from 'react';
import { Button, Img, Text } from '../../Atoms';
import Itelis from '../../assets/img/itelis.png';
import SanteClair from '../../assets/img/santeClair.png';
import { Col, Row } from 'react-bootstrap';
import { LinkHealthOrganism } from '../../Organisms';
import TeleConsult from '../../assets/img/TELECONSULT.png';
import Souris from '../../assets/img/souris.png';
import Earth from '../../assets/img/globe.png';
import Lunette from '../../assets/img/LUNETTES.png';
import Medecin from '../../assets/img/medecin.png';
import Loop from '../../assets/img/doc loupe.png';
import Pills from '../../assets/img/pills.png';
import ReactPlayer from 'react-player';
import { HealthServiceEnum } from '../../Config/enums';
import AtomLoader from '../../Atoms/AtomLoader/AtomLoader';

function TemplateHealthService(props) {
  function responsiveWidth() {
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    console.log(width);
    if (width < 992) {
      return '100%';
      // return width - 200;
    } else return width / 4;
  }
  function responsiveHeight() {
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    var height = window.innerHeight > 0 ? window.innerHeight : screen.height;
    console.log(width);
    if (width < 992) {
      return height / 4;
    } else return height / 4;
  }
  const HealthServiceCenterScreen = ({ children }) => {
    return (
      <div
        style={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          paddingBottom: '5vh'
        }}
      >
        {children}
      </div>
    );
  };

  return (
    <div
      className="template-document template-send-document template-scroll"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Text text="Mes services santé" className="title-document" />
      {!props.state.fetchDone ? (
        <HealthServiceCenterScreen>
          <AtomLoader
            type={null}
            width="3em"
            height="3em"
            backgroundColor={'#ddd'}
          />
        </HealthServiceCenterScreen>
      ) : !props.state.hasHealthService ? (
        <HealthServiceCenterScreen>
          <p className="no-health-services-text">
            Vous n'avez pas accès aux services de santé avec votre contrat.
          </p>
        </HealthServiceCenterScreen>
      ) : (
        <div className="container-health-service" style={{ paddingBottom: 70 }}>
          <div className="content-health-service">
            {/*<Row>*/}
            {/*<Col xs={12} md={6} lg={7}>*/}
            <div className="video-text-container">
              <div style={{ paddingRight: 38, width: "100%" }}>
                <Text
                  text={
                    props.state.content === HealthServiceEnum.SANTECLAIR
                      ? "Qu'est ce que Santé Clair?"
                      : props.state.content === HealthServiceEnum.ITELIS
                      ? 'Qu’est ce qu’Itelis ?'
                      : props.state.content === HealthServiceEnum.CARTEBLANCHE
                      ? 'Qu’est ce que Carte Blanche ?'
                      : props.state.content === HealthServiceEnum.KALIXIA
                      ? 'Qu’est ce que Kalixia ?'
                      : ''
                  }
                  className="title-type-health"
                />
                <p className="health-service-text">
                  {props.state.content === HealthServiceEnum.SANTECLAIR ? (
                    <>
                      {
                        "Pour vous aider à faire des choix éclairés pour votre santé et celle de votre famille, SPVIE vous propose les services d'un vrai repère santé : "
                      }
                      <span className="health-bold-text">{'Santéclair.'}</span>
                      <div>
                        {
                          'Optique, dentaire, audioprothèse, diététique, ostéopathie, médecine généraliste... Avec Santéclair, vous'
                        }
                        <span className="health-bold-text">
                          {' contrôlez vous dépenses de santé,'}
                        </span>
                        {
                          ' vous accédez à des soins et des équipements de qualité et vous trouvez les '
                        }
                        <span className="health-bold-text">
                          {
                            ' praticiens et les établissements les plus adaptés à vos besoins de santé.'
                          }
                        </span>
                      </div>
                    </>
                  ) : props.state.content === HealthServiceEnum.ITELIS ? (
                    <>
                      {
                        'Itelis est un réseau de soin qui vous propose des services dans le domaine de la santé. Notre mission ?'
                      }
                      <span className="health-bold-text">
                        {
                          ' Favoriser l’accès à la santé dans les meilleures conditions. '
                        }
                      </span>
                      {
                        'Nous vous proposons un réseau de 9000 professionnels partout en France pour vous '
                      }
                      {
                        'offrir plus de qualité et plus d’économie dans des domaines très demandés : '
                      }
                      <em>
                        Optique, Dentaire, Audio, Chirurgie Réfractive,
                        Ostéopathie/Chiropraxie, Psychologie et Diététique.
                      </em>
                    </>
                  ) : props.state.content === HealthServiceEnum.CARTEBLANCHE ? (
                    <>
                      Carte Blanche est un réseau de soin spécialisé dans l’optique, le dentaire, l’implantologie et l’audio. Leur mission est de vous faciliter l’accès à des soins de qualité à un juste prix ! Ils contrôlent les engagements des professionnels de santé et généralisent le tiers payant.<br/><br/>
                      L’objectif étant de diminuer votre reste à charge (montant qui sera à votre charge à la suite du remboursement de l’assurance maladie et de votre complémentaire) tout en veillant sur la qualité des prestations et équipements (verres, lentilles, prothèses dentaires et auditives).
                    </>
                  ) : props.state.content === HealthServiceEnum.KALIXIA ? (
                    <>
                      Kalixia est un réseau de soins qui vous donne accès avec le tiers-payant systématique à de nombreux professionnels de santé répartis sur tout le territoire :<br />
                      - plus de 7 100 centres en optique<br />
                      - 5 400 en audio<br />
                      - 500 ostéopathes (hors tiers-payant)<br />
                    </>
                  ) : props.state.content === HealthServiceEnum.KALIVIA ? (
                    <>
                      Kalixia est un réseau de soins qui vous donne accès avec le tiers-payant systématique à de nombreux professionnels de santé répartis sur tout le territoire :<br />
                      - plus de 7 100 centres en optique<br />
                      - 5 400 en audio<br />
                      - 500 ostéopathes (hors tiers-payant)<br />
                    </>
                  ) : (
                    <div></div>
                  )}
                </p>
              </div>
              {/*</Col>*/}
              {/*<Col xs={12} md={6} lg={5} className="container-img-health">*/}
              <div className="video-responsive">
                <ReactPlayer
                  url={
                    props.state.content === HealthServiceEnum.SANTECLAIR
                      ? `https://www.youtube.com/embed/8R12WWGIacY`
                      : props.state.content === HealthServiceEnum.ITELIS
                      ? `https://www.youtube.com/embed/MkfbBH7fG5Q`
                      : props.state.content === HealthServiceEnum.KALIXIA
                      ? `https://www.youtube.com/embed/8dJYjDM-KTA` :
                      props.state.content === HealthServiceEnum.KALIVIA
                      ? `https://www.youtube.com/embed/8dJYjDM-KTA`
                      : `https://www.youtube.com/embed/Q660TA9pxGc`
                  }
                  playing={false}
                  width={responsiveWidth()}
                  height={responsiveHeight()}
                />
              </div>
            </div>
            {/*</Col>*/}
            {/*</Row>*/}
            {props.state.content !== HealthServiceEnum.CARTEBLANCHE ? (
                <Text
                  text={'Quels sont les principaux services proposés ?'}
                  className="title-type-health"
                />
            ) : null}
          </div>
          {props.state.content !== HealthServiceEnum.CARTEBLANCHE ? (
            <div className="content-link-health-service-container">
              <div className="content-link-health-service">
                <div className="content-link-health-service-items-container">
                  {/* #1 icon */}
                  <div className="link-health-element-container">
                    <LinkHealthOrganism
                      text={props.state.content === HealthServiceEnum.KALIXIA ? "L’accès à des soins qualitatifs" : "Téléconsultation médicale"}
                      src={TeleConsult}
                      imgDirection="vertical"
                    />
                  </div>
                  {/* #2 icon */}
                  <div className="link-health-element-container">
                    <LinkHealthOrganism
            text={props.state.content === HealthServiceEnum.KALIXIA ? "Un dispositif de géolocalisation enrichi" : "Géolocalisation et présentation des praticiens partenaires"}
                      src={Earth}
                      imgDirection="circle"
                    />
                  </div>
                  {/* #3 icon */}
                  <div className={`link-health-element-container ${props.state.content === HealthServiceEnum.KALIXIA ? 'link-health-element-last-kalixia' : ''}`}>
                    <LinkHealthOrganism
                      imageClassName={
                        props.state.content !== HealthServiceEnum.ITELIS &&
                        'img-loop'
                      }
                      text={
                        props.state.content === HealthServiceEnum.ITELIS
                          ? 'Garantie et dépannage optique'
                          : props.state.content === HealthServiceEnum.SANTECLAIR
                          ? 'Analyse tarifaire de vos devis'
                          : 'Des tarifs avantageux !*'
                      }
                      src={
                        props.state.content === HealthServiceEnum.ITELIS
                          ? Lunette
                          : Loop
                      }
                      imgDirection="horizontale"
                    />
                  </div>
                  {/* #4 icon */}
                  {props.state.content !== HealthServiceEnum.KALIXIA && (
                    <div className="link-health-element-container">
                      <LinkHealthOrganism
                        imageClassName={
                          props.state.content !== HealthServiceEnum.ITELIS &&
                          'img-doctor'
                        }
                        text={
                          props.state.content === HealthServiceEnum.ITELIS
                            ? 'Tests en ligne (optique et ouïe)'
                            : props.state.content === HealthServiceEnum.SANTECLAIR
                  ? 'Second avis médical par un spécialiste'
                  : 'Newsletter infos santé'
                        }
                        src={
                          props.state.content === HealthServiceEnum.ITELIS
                            ? Souris
                            : Medecin
                        }
                        imgDirection="circle"
                      />
                    </div>
                  )}
                </div>
              </div>
              {props.state.content === HealthServiceEnum.KALIXIA && (
                <div className={'content-link-health-service-asterix'}>
                  *jusqu’à – 40 % sur les verres de classe B, – 30 % sur les lentilles; – 20% sur les montures, - 500€ en moyenne pour double appareillage auditif de classe 2
                </div>
              )}
            </div>
          ) : null}
          <Button
            style={{marginTop: props.state.content === HealthServiceEnum.CARTEBLANCHE ? 30 : undefined}}
            text={
              props.state.content === HealthServiceEnum.ITELIS
                ? 'Accéder à Itelis'
                : props.state.content === HealthServiceEnum.SANTECLAIR
                ? 'Accédez à My Santé Clair'
                : props.state.content === HealthServiceEnum.KALIXIA
                ? 'Accédez à Kalixia'
                : props.state.content === HealthServiceEnum.KALIVIA
                ? 'Accédez à Kalixia'
                : 'Accédez à Carte Blanche'
            }
            className="btn-change-health"
            onClick={() => props.onGoToHealthServiceWebsite()}
          />
        </div>
      )}
    </div>
  );
}
export default TemplateHealthService;
